module.exports = __webpack_public_path__ + "static/img/萧.8a05a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/萧.png
// module id = FLtl
// module chunks = 4